const minimalOrderUpdate = (state, action) => {
  return Object.assign({}, state, action.payload);
};
export default minimalOrderUpdate;
